/**
 * Switches the Cloud Limo Manager palette on for everything a layout renders.
 *
 * Every limo colour rule is scoped to `body.admin-limo-mode` or
 * `.admin-shell--limo` (src/index.css and the component stylesheets). A layout
 * that does not attach them renders a limo tenant in contractor colours, with
 * nothing failing: the customer portal did until LIMO-203, and the staff portal
 * did until this hook - chauffeurs saw the contractor navy rail and an amber
 * avatar.
 *
 * Both hooks are needed. The class on <body> reaches what MUI portals outside
 * the layout (dialogs, menus, poppers); the class on the shell is the layout's
 * own scope. Call this from EVERY layout a tenant user can land in, and put the
 * returned suffix on the shell's className. layoutThemeHooks.test.js fails for
 * a layout that does neither and is not listed there as exempt.
 *
 * A LAYOUT effect, so the class is on <body> before the first paint. With a
 * plain effect the page painted contractor colours first and then switched -
 * and the sidebar has `transition: all 0.2s`, so every load visibly faded from
 * the contractor navy rail to the limo one. isLimo is derived from the hostname
 * (ProductContext), so it is already right on the first render.
 */
import { useLayoutEffect } from "react";

export const LIMO_BODY_CLASS = "admin-limo-mode";
export const LIMO_SHELL_CLASS = "admin-shell--limo";

export default function useLimoTheme(isLimo) {
  useLayoutEffect(() => {
    if (isLimo) document.body.classList.add(LIMO_BODY_CLASS);
    else document.body.classList.remove(LIMO_BODY_CLASS);
    return () => document.body.classList.remove(LIMO_BODY_CLASS);
  }, [isLimo]);
  return isLimo ? ` ${LIMO_SHELL_CLASS}` : "";
}
